/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskCoreLogicCrimeEntry } from './ExecRiskCoreLogicCrimeEntry';
import {
    ExecRiskCoreLogicCrimeEntryFromJSON,
    ExecRiskCoreLogicCrimeEntryFromJSONTyped,
    ExecRiskCoreLogicCrimeEntryToJSON,
} from './ExecRiskCoreLogicCrimeEntry';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedCoreLogicResponse
 */
export interface ExecRiskPaginatedCoreLogicResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedCoreLogicResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskCoreLogicCrimeEntry>}
     * @memberof ExecRiskPaginatedCoreLogicResponse
     */
    results: Array<ExecRiskCoreLogicCrimeEntry>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedCoreLogicResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedCoreLogicResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedCoreLogicResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedCoreLogicResponse interface.
 */
export function instanceOfExecRiskPaginatedCoreLogicResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedCoreLogicResponseFromJSON(json: any): ExecRiskPaginatedCoreLogicResponse {
    return ExecRiskPaginatedCoreLogicResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedCoreLogicResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedCoreLogicResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskCoreLogicCrimeEntryFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedCoreLogicResponseToJSON(value?: ExecRiskPaginatedCoreLogicResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskCoreLogicCrimeEntryToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

